<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-09-27 14:22:14
 * @LastEditors: wk
 * @LastEditTime: 2019-09-30 14:18:26
 -->
<template>
  <div class="file-upload">
    <el-upload
      name='data'
      :action="uploadUrl"
      :before-upload="handleBeforeUpload"
      :on-progress="handleProgress"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-preview="handlePreview"
      :with-credentials='true'
      :accept="accept"
      :limit="1"
      :file-list="fileList">
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传{{accept}}文件，且不超过{{sizeMsg}}</div>
    </el-upload>
  </div>
</template>

<script>
import * as filter from '@core/filters'

export default {
  name: 'fileUpload',
  props: {
    value: {
      type: [Array, String],
      default: ''
    },
    uploadUrl: {
      type: String,
      default: filter.getUploadHost('/cdnadmin/admin/upload/uploadFile_json')
    },
    accept: {
      type: String,
      default: '.xlsx,.docx'
    },
    size: {
      type: Number,
      default: 1024 * 1024 * 10
    }
  },
  computed: {
    sizeMsg() {
      const mb = (this.size / 1024 / 1024).toFixed(2)
      let res
      if (mb < 1) {
        res = `${this.size / 1024}KB`
      } else {
        res = `${mb}MB`
      }
      return res
    }
  },
  data() {
    return {
      fileList: [] // 上传的文件列表集合
    }
  },
  watch: {
    fileList(val) {
      const arr = val.map(item => `${item.url}?attname=${item.name}`)
      this.$emit('input', arr.join(',')).$emit('change', this.fileList)
    }
  },
  methods: {
    // 上传之前校验格式，大小
    handleBeforeUpload(file) {
      if (this.size && file.size > this.size) {
        this.$message.error(`上传文件大小限制最大${this.sizeMsg}`)
        return false
      }
      const formatReg = new RegExp(this.accept.replace(/,/g, '|'), 'i')
      if (!formatReg.test(file.name)) {
        this.$message.error('格式不正确,请重新上传')
        return false
      }
    },
    // 文件上传时的钩子
    handleProgress() {
      // this.loading = true
    },
    // 文件上传成功时的钩子
    handleSuccess(res, files) {
      const arr = [].concat(this.fileList)
      const file = {
        name: files.name,
        url: files.response.url
      }
      arr.push(file)
      this.fileList = arr
    },
    // 文件上传失败时的钩子
    handleError(err, file) {
      this.$message.error(`"${file.name}"文件上传失败`)
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log(file)
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.fileList = fileList || []
    }
  }
}
</script>

<style lang="less" scoped>
</style>
